export default "__VITE_ASSET__CVs0h5oH__"